import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const navItems = [
    { label: '首页', href: '/home', match: (p) => p === '/home' },
    { label: '博客广场', href: '/blogs', match: (p) => p.startsWith('/blogs') },
    { label: '星球穿梭', href: '/planet-shuttle', external: true },
    { label: '提交博客', href: '/blog-requests/add', match: (p) => p.startsWith('/blog-requests/add') },
    { label: '审核结果', href: '/blog-requests', match: (p) => p.startsWith('/blog-requests') && !p.startsWith('/blog-requests/add') },
    { label: '关于本站', href: '/about', match: (p) => p === '/about' },
];

export default function Header() {
    const [pathname, setPathname] = useState('');
    const { isDark, toggleTheme } = useTheme();

    useEffect(() => {
        setPathname(window.location.pathname);
    });

    return (
        <header className="redesign-header">
            <div className="redesign-header-inner">
                <a href="/home" className="redesign-logo">
                    <span className="redesign-logo-dark">博客</span>
                    <span className="redesign-logo-accent">中心</span>
                </a>

                <nav className="redesign-nav">
                    {navItems.map((item) => {
                        const active = !item.external && item.match(pathname);
                        if (item.external) {
                            return (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="redesign-nav-link"
                                >
                                    {item.label}
                                </a>
                            );
                        }
                        return (
                            <a
                                key={item.href}
                                href={item.href}
                                className={`redesign-nav-link${active ? ' active' : ''}`}
                            >
                                {item.label}
                            </a>
                        );
                    })}
                </nav>

                <div className="redesign-header-actions">
                    <button
                        type="button"
                        className="redesign-theme-btn"
                        onClick={toggleTheme}
                        aria-label={isDark ? '切换到亮色模式' : '切换到暗色模式'}
                    >
                        {isDark ? <Sun size={18} /> : <Moon size={18} />}
                    </button>
                </div>
            </div>
        </header>
    );
}
